import {
  createAppI18n,
  defaultLang,
  loadLocalTranslations,
  registerI18nInstance
} from '@shared/locales'

import dayjs from 'dayjs'

export const insuranceI18n = createAppI18n()

const initializeInsuranceI18n = async (lang: string) => {
  await loadLocalTranslations(insuranceI18n, 'insurance', lang)

  dayjs.locale('ro')
}

registerI18nInstance(insuranceI18n)

let lastLoadedLang: string | null = null

insuranceI18n.on('languageChanged', async (newLang) => {
  if (newLang !== lastLoadedLang) {
    await initializeInsuranceI18n(newLang)
    lastLoadedLang = newLang
  }
})

const initializeDefaultLanguage = async () => {
  const lang = insuranceI18n.language || defaultLang.value

  await initializeInsuranceI18n(lang)
}

initializeDefaultLanguage()
